/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import Button from '@Components/Button';
import GeneralDialogLayout from '@Containers/Dialogs/GeneralDialogLayout/GeneralDialogLayout';

function ConfirmationPopup(props) {
  const {
    title,
    text,
    submitButtonText,
    dismissButtonText,
    isCancelButton,
    registerText,
    onClose,
    onConfirm,
    onRegister,
    closed,
    selfClose,
  } = props;
  useEffect(
    () => () => {
      onClose();
    },
    []
  );
  return (
    <>
      <div className="react-dialogs-backdrop" />
      <GeneralDialogLayout
        className="history-confirmation-popup"
        resizable={false}
        movable={false}
        closeBtn={false}
        selfClose={selfClose}
        backdrop={false}
        closed={closed}>
        <div className="rx-newmodal notify information" role="dialog" aria-labelledby="history-confirm-dialog-title">
          <header className="rx-newmodal-header">
            <h4 id="history-confirm-dialog-title" className="rx-newmodal-title">
              {title}
            </h4>
            <div className="notify-icon">i</div>
          </header>
          <section className="rx-newmodal-content">{text}</section>
          <footer className="rx-newmodal-footer">
            <span className="rx-btn-group--right history-btn-group">
              {isCancelButton && (
                <Button
                  type="button"
                  name="cancel"
                  onClick={onClose}
                  buttonConfig={{
                    type: 'primary',
                    size: 'sm',
                    label: dismissButtonText,
                    e2eName: 'confirmation-modal-cancel',
                  }}
                  iconConfig={{ name: 'delete' }}
                />
              )}
              <Button
                type="button"
                name="confirm"
                onClick={onConfirm}
                buttonConfig={{
                  type: 'primary',
                  size: 'sm',
                  label: submitButtonText,
                  e2eName: 'confirmation-modal-submit',
                }}
                iconConfig={{ name: 'chevron-right' }}
              />
              {registerText && (
                <Button
                  type="button"
                  name="register"
                  onClick={onRegister}
                  buttonConfig={{
                    type: 'primary',
                    size: 'sm',
                    label: registerText,
                    e2eName: 'confirmation-modal-register',
                  }}
                  iconConfig={{ name: 'chevron-right' }}
                />
              )}
            </span>
          </footer>
        </div>
      </GeneralDialogLayout>
    </>
  );
}
ConfirmationPopup.defaultProps = {
  onConfirm: () => {},
  onClose: () => {},
  onRegister: () => {},
  submitButtonText: 'Yes',
  dismissButtonText: 'Cancel',
  isCancelButton: true,
};
ConfirmationPopup.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  submitButtonText: PropTypes.string,
  dismissButtonText: PropTypes.string,
  registerText: PropTypes.string,
  isCancelButton: PropTypes.bool,
  onConfirm: PropTypes.func,
  onClose: PropTypes.func,
  onRegister: PropTypes.func,
  selfClose: PropTypes.func,
  closed: PropTypes.bool,
};
export default withRouter(ConfirmationPopup);
